"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfluencerMethods = exports.Influencer = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Represents an entry in the "influencers" table.
 */
var InfluencerMethods = /*#__PURE__*/function () {
  function InfluencerMethods() {
    _classCallCheck(this, InfluencerMethods);
  }

  _createClass(InfluencerMethods, null, [{
    key: "getFullName",
    value: function getFullName(influencer) {
      return "".concat(influencer.first_name, " ").concat(influencer.last_name);
    }
  }, {
    key: "getAvatarUrl",
    value: function getAvatarUrl(influencer) {
      var _influencer$instagram, _influencer$tiktok_us;

      return ((_influencer$instagram = influencer.instagram_user) === null || _influencer$instagram === void 0 ? void 0 : _influencer$instagram.avatar_url) || ((_influencer$tiktok_us = influencer.tiktok_user) === null || _influencer$tiktok_us === void 0 ? void 0 : _influencer$tiktok_us.avatar_url);
    }
  }, {
    key: "getFormattedInstagramHandle",
    value: function getFormattedInstagramHandle(influencer) {
      var _influencer$instagram2;

      return (_influencer$instagram2 = influencer.instagram_user) !== null && _influencer$instagram2 !== void 0 && _influencer$instagram2.user_name ? "@".concat(influencer.instagram_user.user_name) : '';
    }
  }, {
    key: "getFormattedTikTokHandle",
    value: function getFormattedTikTokHandle(influencer) {
      var _influencer$tiktok_us2, _influencer$tiktok_us3, _influencer$extra_fie;

      // Always return handle from connected user if it exists
      var userName = (_influencer$tiktok_us2 = (_influencer$tiktok_us3 = influencer.tiktok_user) === null || _influencer$tiktok_us3 === void 0 ? void 0 : _influencer$tiktok_us3.user_name) !== null && _influencer$tiktok_us2 !== void 0 ? _influencer$tiktok_us2 : (_influencer$extra_fie = influencer.extra_fields) === null || _influencer$extra_fie === void 0 ? void 0 : _influencer$extra_fie.tiktok_username;
      return userName ? "@".concat(userName) : '';
    }
  }, {
    key: "hasCreatorProfile",
    value: function hasCreatorProfile(influencer) {
      return !!influencer.creator_profile;
    }
  }, {
    key: "hasEmail",
    value: function hasEmail(influencer) {
      return !!influencer.primary_email;
    }
  }, {
    key: "isInfluencerBeingUpdated",
    value: function isInfluencerBeingUpdated(influencer) {
      return influencer.$$uiPending;
    }
  }]);

  return InfluencerMethods;
}();
/**
 * @deprecated - use the influencer methods instead
 */


exports.InfluencerMethods = InfluencerMethods;

var Influencer = /*#__PURE__*/function () {
  function Influencer(data) {
    _classCallCheck(this, Influencer);

    _defineProperty(this, "$$uiPending", false);

    Object.assign(this, data);
  }

  _createClass(Influencer, [{
    key: "getFullName",
    value: function getFullName() {
      return "".concat(this.first_name, " ").concat(this.last_name);
    }
  }, {
    key: "getAvatarUrl",
    value: function getAvatarUrl() {
      var _this$instagram_user, _this$tiktok_user;

      return ((_this$instagram_user = this.instagram_user) === null || _this$instagram_user === void 0 ? void 0 : _this$instagram_user.avatar_url) || ((_this$tiktok_user = this.tiktok_user) === null || _this$tiktok_user === void 0 ? void 0 : _this$tiktok_user.avatar_url);
    }
  }, {
    key: "getFormattedInstagramHandle",
    value: function getFormattedInstagramHandle() {
      var _this$instagram_user2;

      return (_this$instagram_user2 = this.instagram_user) !== null && _this$instagram_user2 !== void 0 && _this$instagram_user2.user_name ? "@".concat(this.instagram_user.user_name) : '';
    }
  }, {
    key: "getFormattedTikTokHandle",
    value: function getFormattedTikTokHandle() {
      var _this$tiktok_user$use, _this$tiktok_user2, _this$extra_fields;

      // Always return handle from connected user if it exists
      var userName = (_this$tiktok_user$use = (_this$tiktok_user2 = this.tiktok_user) === null || _this$tiktok_user2 === void 0 ? void 0 : _this$tiktok_user2.user_name) !== null && _this$tiktok_user$use !== void 0 ? _this$tiktok_user$use : (_this$extra_fields = this.extra_fields) === null || _this$extra_fields === void 0 ? void 0 : _this$extra_fields.tiktok_username;
      return userName ? "@".concat(userName) : '';
    }
  }, {
    key: "hasCreatorProfile",
    value: function hasCreatorProfile() {
      return !!this.creator_profile;
    }
  }, {
    key: "hasEmail",
    value: function hasEmail() {
      return !!this.primary_email;
    }
  }, {
    key: "isBeingUpdated",
    value: function isBeingUpdated() {
      return this.$$uiPending;
    }
  }]);

  return Influencer;
}();

exports.Influencer = Influencer;